/**
 * jQuery debug plugin
 * LOL Design 2016/2017
 * Version: 0.1.0
 */
 
(function ( $ ) {
    $.ld_debug = function ( text ) {
	    if ( $.ld_is_development() ) {
			console.log( text ); 
	    }  
    };
})( jQuery );

// decide environment
(function ( $ ) {
    $.ld_is_development = function ( ) {
	    if ( $( 'body' ).hasClass( 'env_local' ) ) {
			return true;
	    } else {
			return false;
	    }
    };
})( jQuery );